import { useQueryClient } from 'react-query';
import {
  subscriptionApiKeys,
  useSubscriptionApi,
} from '@hooks/api/account/useSubscriptionApi/useSubscriptionApi';
import { usePatchPutApi } from '@hooks/api/usePatchPutApi';
import type { PatchPutApiOptions } from 'types/api';

export function useUpdateDefaultPaymentMethod(
  organizationId: string,
  options?: Partial<PatchPutApiOptions<void, { paymentMethodId: string }>>
) {
  const api = useSubscriptionApi();
  const queryClient = useQueryClient();

  const {
    update: updateDefaultPaymentMethod,
    isUpdating: isUpdatingPaymentMethod,
  } = usePatchPutApi<void, { paymentMethodId: string }>({
    getSuccessMessage: () => 'Default payment method updated!',
    request: (params) => api.updateDefaultPaymentMethod(organizationId, params),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(
        subscriptionApiKeys.getPaymentMethods(organizationId)
      );
      queryClient.invalidateQueries(
        subscriptionApiKeys.getActiveSubscriptions(organizationId)
      );
      options?.onSuccess?.(data, variables, context);
    },
  });

  return {
    isUpdatingPaymentMethod,
    updateDefaultPaymentMethod,
  };
}
